import { P2GText } from '@parcel2go/core-ui';

import { PaymentOptionType } from '~/lib/api/smartsend/types';
import AlertWithIcon from '../../../AlertWithIcon';
import { P2GProgress } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  paymentOption: PaymentOptionType;
}

const ProviderGroupSummaryBooking: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  switch (props.paymentOption) {
    case 'External':
      return (
        <AlertWithIcon color={'info'} loader={<P2GProgress />}>
          <P2GText component="p" colour="primary" variant="body2">
            {t('GENERATING_PAYMENT_LINK_ALERT', { defaultValue: 'Generating payment link...' })}
          </P2GText>
        </AlertWithIcon>
      );

    default:
      return (
        <AlertWithIcon color={'info'} loader={<P2GProgress />}>
          <P2GText component="p" colour="primary" variant="body2">
            {t('PLEASE_WAIT_INFO', { defaultValue: 'Please wait while we book your parcels...' })}
          </P2GText>
        </AlertWithIcon>
      );
  }
};

export default ProviderGroupSummaryBooking;
